"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    maxCharacters: 'Maximum %{charCount} characters',
    charactersRemaining: '%{charCount} characters remaining',
    maxCharsMessage: 'Must not exceed %{charCount} characters'
  },
  fr: {
    maxCharacters: '%{charCount} caractères maximum',
    charactersRemaining: '%{charCount} caractères restants',
    maxCharsMessage: 'Ne doit pas dépasser %{charCount} caractères'
  }
};